export interface NotificationState {
    notificationData: NotificationData | null;
    fetchInProgress: boolean;
    error?: any;
}

export const INIT_NOTIFICATION_STATE: NotificationState = {
    notificationData: null,
    fetchInProgress: false,
    error: null
};


export interface NotificationData {
    token?: string ;
    body?: string;
}

